import { useTranslator } from '@bluebeam/react-i18n';
import ValidateInternetConnection from 'components/App/ValidateInternetConnection';
import { FeatureFlagsProvider } from 'featureFlags';
import { AnalyticsProvider } from 'analytics';
import { History } from 'history';
import IndexPage from 'pages/IndexPage';
import AndroidPage from 'pages/redirects/AndroidPage';
import iPhonePage from 'pages/redirects/iPhonePage';
import SubscriptionUpgradePage from 'pages/SubscriptionUpgradePage/SubscriptionUpgradePage';
import { createI18nProvider } from 'providers/i18nProvider';
import * as React from 'react';
import { Redirect, Router, Switch } from 'react-router-dom';
import ToastSubscriptions from 'utils/toast/ToastSubscriptions';
import { addGtmScripts, removeGtmScript } from 'constants/google-tag-manager';
import AppRoutes from './AppRoutes';
import { BannerContext } from './BannerContext';
import { Route } from './Route';

type Props = {
  history: History;
};
const I18nProvider = createI18nProvider();

// Add Google Tag Manager to landing page only
const useGoogleTagManager = (path: string) => {
  React.useEffect(() => {
    if (path === '/') {
      addGtmScripts();
    }
    return () => {
      removeGtmScript();
    };
  }, [path]);
};

const Routes: React.FC<Props> = (props: Props) => {
  const { history } = props;
  const [bannerHeight, setBannerHeight] = React.useState(0);

  useGoogleTagManager(history.location.pathname);

  return (
    <I18nProvider>
      <BannerContext.Provider
        value={{ height: bannerHeight, setHeight: setBannerHeight }}
      >
        <FeatureFlagsProvider>
          <AnalyticsProvider>
            <ToastSubscriptions />
            <Router history={history}>
              <Switch>
                <Route path="/" exact component={IndexPage} />
                <Route
                  path="/subscription"
                  exact
                  component={SubscriptionUpgradePage}
                />
                <Route path="/iphone" component={iPhonePage} />
                <Route path="/android" component={AndroidPage} />
                <Route
                  path={[
                    '/auth',
                    '/dashboard',
                    '/my-workspace',
                    '/project',
                    '/projects',
                    '/connected-accounts',
                    '/sessions',
                    '/studio-projects',
                    '/labs',
                    '/documents',
                    '/org-admin',
                  ]}
                  component={AppRoutes}
                />
                <Redirect to="/my-workspace" />
              </Switch>
            </Router>
            <ValidateInternetConnection />
          </AnalyticsProvider>
        </FeatureFlagsProvider>
      </BannerContext.Provider>
    </I18nProvider>
  );
};

export default Routes;
